import { useGetContextsQuery } from "Auth/Api/Queries/Context/useGetContextsQuery";
import { LicenseOrderFormSkeleton } from "Components/Licenses/LicenseOrderForm/LicenseOrderFormSkeleton";
import { LicenseSelectionStep } from "Components/Onboarding/BusinessEntity/Steps/LicenseSelectionStep/LicenseSelectionStep";
import { IdentityUserStatus } from "Infrastructure/Api/Api";
import { AccessRoleCodes } from "Models/AccessRoleCodes";

type Props = {
  onNextStepRequested: () => void;
};

/**
 * Add-role variant of the license step: the hunter can still attach an affiliate code here
 * (ZS-1024) — it is tied to the Onboarding Hunter role, which only the add-role wizard has.
 */
export const AddRoleLicenseSelectionStep = ({ onNextStepRequested }: Props) => {
  const { data, isLoading } = useGetContextsQuery();

  // Which role is active decides whether the affiliate field shows — wait for it, so the field
  // never pops in after the rest of the step.
  if (isLoading) {
    return <LicenseOrderFormSkeleton />;
  }

  const activeContext = data?.contexts.find(
    (context) =>
      context.identityUserPublicID === data.activeIdentityUserPublicID,
  );
  const isOnboardingHunter =
    activeContext?.accessRoleCode === AccessRoleCodes.Hunter &&
    activeContext.status === IdentityUserStatus.Onboarding;

  return (
    <LicenseSelectionStep
      onNextStepRequested={onNextStepRequested}
      affiliateIdentityUserPublicID={
        isOnboardingHunter ? activeContext.identityUserPublicID : undefined
      }
    />
  );
};
